<template>
  <f7-page :page-content="false">
    <f7-navbar>
      <f7-nav-left>
        <f7-link v-if="!esPopup" @click.stop="$f7router.back()">&lt; {{ $t('atras') }}</f7-link>
      </f7-nav-left>
      <f7-nav-title v-if="id && !readonly" sliding>
        {{$t('tarea.editar')}}<span v-if="rformData && rformData.codigo"> - {{ rformData.codigo }}</span>
      </f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>
        {{$t('tarea.tarea')}}<span v-if="rformData && rformData.codigo"> - {{ rformData.codigo }}</span>
      </f7-nav-title>
      <f7-nav-title v-else sliding>
        {{$t('tarea.nuevo')}}
      </f7-nav-title>
      <f7-nav-right>
        <f7-button
          v-if="!readonly"
          fill
          icon-f7="floppy_disk"
          text="Guardar"
          class="display-flex"
          @click="$refs.rform && $refs.rform.saveItem()"
        ></f7-button>
        <f7-button
          v-if="readonly"
          fill
          icon-f7="arrow_right_square"
          text="Tarea siguiente"
          class="display-flex"
          @click="tareaSiguiente()"
        ></f7-button>
        <template
            slot="right"
            v-if="rformData && rformData.estado" 
          >
            <div class="menu-item menu-item-dropdown bg-color-primary" >
              <div class="menu-item-content"><i class="f7-icons">ellipsis_vertical</i></div>
              <div class="menu-dropdown menu-dropdown-right bg-color-primary" style="z-index:10">
                <div class="menu-dropdown-content bg-color-primary text-align-right">
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="readonly && rformData"
                    @click="readonly=false">{{$t('Editar')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer"
                    v-if="rformData && rformData.estado == 'PENDIENTE'" 
                    @click="popupPlanificarOpened = true">{{$t('Planificar')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer"
                    v-if="rformData && rformData.estado == 'PLANIFICADA'" 
                    @click="desplanificarTarea">{{$t('Desplanificar')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer"
                    @click="cancelarEdicion">{{$t('Cancelar edición')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="readonly" @click.prevent="enviarEmail = true">{{$t('Enviar e-mail')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="rformData && rformData.estado == 'PENDIENTE'" @click="deleteItem">{{$t('Eliminar')}}</div>
                </div>
              </div>
            </div>
        </template>
      </f7-nav-right>
    </f7-navbar>
    <f7-page-content>
      <r-form
        ref="rform"
        :itemId="id"
        @save="onSave"
        :readonly="readonly"
        :dbAdapter="Tarea"
        :defaultData="defaultData"
        :documentoAdapter="Documento"
        :beforeSave="beforeSave"
        @loadItem="loadItem"
        @mounted="onRFormMounted"
      >
      <template v-slot:default="{ rform }">
      <f7-card class="padding-vertical-half padding-right">
        <div name="datos_generales" style="display: flex;justify-content: center;">
          <div style="height: 12px;"></div>
          <f7-button
            v-if="readonly && !rform.formData.idOportunidad && !rform.formData.idCampania"
            class="col-20"
            icon-f7="rectangle_stack_person_crop_fill"
            @click="crearOportunidad"
          >Crear oportunidad</f7-button>
          <f7-link
            @click="showDetalle = !showDetalle"
            :tooltip="showDetalle ? 'Ocultar Detalle' : 'Mostrar Detalle'"
            :icon-f7="showDetalle ?'chevron_compact_up' : 'chevron_compact_down'"
            :title="showDetalle ? 'Ocultar Detalle' : 'Mostrar Detalle'"
            style="padding-left: 7px;font-size: 10px;float: right;position: absolute;right: 10px;"
          ></f7-link>
        </div>
        <f7-card-content v-show="showDetalle">
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100" :medium="esPopup ? '100' : '50'">
              <ul>
                <r-input
                  outline
                  floating-label
                  :label="$t('tarea.codigo')"
                  :form="rform"
                  type="text"
                  name="codigo"
                  v-if="readonly"
                ></r-input>
                <r-input
                  v-if="readonly && rform && rform.formData && rform.formData.estado"
                  floating-label
                  :label="$t('tarea.estado')"
                  :form="rform"
                  type="badge"
                  name="estado"
                  :readonly="true"
                  :color="getColorBadgeEstado(rform.formData.estado)"
                  :text="rform.formData.estado"
                ></r-input>
                <r-input
                  v-else
                  floating-label
                  :label="$t('tarea.estado')"
                  :form="rform"
                  type="select"
                  name="estado"
                  :color="getColorBadgeEstado(rform.formData.estado)"
                  :text="getTextBadgeEstado(rform.formData.estado)"
                  @change="changeEstado"
                >
                  <option selected disabled></option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="PLANIFICADA">PLANIFICADA</option>
                  <option value="REALIZADA">REALIZADA</option>
                  <option value="CANCELADA">CANCELADA</option>
                </r-input>
                <r-autocomplete
                  outline
                  :dbAdapter="TipoTarea"
                  key="tipoTarea"
                  class="col-100 medium-33"
                  floating-label
                  :label="$t('tarea.tipoTarea')"
                  :form="rform"
                  name="tipo"
                  labelProp="nombre"
                  :idProp="null"
                  prefixProp="codigo"
                  idFieldDetail="id"
                  :shownFields="['id', 'codigo', 'nombre']"
                  :showNavigationLink="false"
                  :validation="{isValid: obj => {return !validator.isEmpty(obj.id, {ignore_whitespace:true})}, errorMessage: '* El tipo de tarea es obligatorio'}"
                ></r-autocomplete>
                <r-input
                  outline
                  floating-label
                  :label="$t('tarea.descripcion')"
                  :form="rform"
                  type="text"
                  name="descripcion"
                  :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* La descripción es obligatoria'}"
                ></r-input>
                <r-input
                  outline
                  floating-label
                  :label="$t('tarea.comentarios')"
                  :form="rform"
                  type="textarea"
                  name="comentarios"
                ></r-input> 
                <resultado-llamada
                  v-if="rform.formData.id"
                  ref="resultadoLlamada"
                  :id-tarea="rform.formData.id"
                  :tipo-codigo="rform.formData.tipo ? rform.formData.tipo.codigo : null"
                  :estado="rform.formData.estado"
                  :estado-inicial="estadoInicial"
                  :readonly="readonly"
                ></resultado-llamada>
                <r-autocomplete
                  v-if="rform.formData.id"
                  outline
                  :dbAdapter="Empleado"
                  key="empleado"
                  class="col-100 medium-33"
                  floating-label
                  :label="$t('tarea.empleado')"
                  :form="rform"
                  name="username"
                  labelProp="nombre"
                  idProp="username"
                  prefixProp="username"
                  idFieldDetail="id"
                  :showNavigationLink="false"
                  :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* El empleado es obligatorio'}"
                ></r-autocomplete>
                <r-autocomplete-m2m
                  v-else
                  outline
                  :dbAdapter="Empleado"
                  key="empleados"
                  class="col-100 medium-33"
                  floating-label
                  :label="'* '+$t('tarea.empleados')"
                  :form="rform"
                  name="empleados"
                  labelProp="nombre"
                  idProp="username"
                  prefixProp="username"
                  idFieldDetail="id"
                  :showNavigationLink="false"
                  type="textarea"
                  :lineBreak="true"
                  :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* El empleado es obligatorio'}"
                ></r-autocomplete-m2m>
                <div v-if="rform && rform.formData && rform.formData.estado && rform.formData.estado != 'PENDIENTE'&& rform.formData.estado && rform.formData.estado != 'CANCELADA'">
                  <r-input
                    outline
                    floating-label
                    class="col-100 medium-50"
                    :label="$t('tarea.fecha')"
                    :form="rform"
                    type="datepicker"
                    name="fechaFecha"
                    :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                  ></r-input>
                  <r-timepicker
                    outline
                    floating-label
                    class="col-100 medium-50"
                    :label="$t('tarea.hora_inicio')"
                    :form="rform"
                    name="fechaHora"
                    :clearButton="true"
                  ></r-timepicker>
                  <r-timepicker
                    v-if="rform && rform.formData && rform.formData.id"
                    outline
                    floating-label
                    class="col-100 medium-50"
                    :label="$t('tarea.hora_final')"
                    :form="rform"
                    name="horaFinal"
                    :clearButton="true"
                    :readonly="true"
                  ></r-timepicker>
                </div>
                <r-input
                  outline
                  floating-label
                  :label="$t('tarea.tiempoEstimado')"
                  :form="rform"
                  name="tiempoEstimado"
                  type="number"
                ></r-input>
                <div
                  v-if="rform && rform.formData && rform.formData.tipo && rform.formData.tipo.codigo == 'T0068'"
                  class="col-100 medium-50"
                >
                  <f7-block-title style="z-index: 30">
                    {{$t('tarea.sesiones')}}
                    <span v-if="duracionAcumuladaSesiones(rform.formData.sesiones, 'number')" style="font-size: 0.75em;padding-right: 4pt;">
                      <f7-icon f7="alarm" size="small" color="primary"></f7-icon>{{duracionAcumuladaSesiones(rform.formData.sesiones)}} | 
                    </span>
                    <f7-link
                      v-if="!readonly"
                      @click="addSesionTarea(rform)"
                    >{{$t('tarea.sesiones_add')}}</f7-link> 
                  </f7-block-title>
                  <f7-card
                    class="elevation-3 padding-vertical-half padding-right"
                    v-for="(item,index) in rform.formData.sesiones"
                    :key="'sesiones-tarea-'+index"
                    :style="'z-index:'+(rform.formData.sesiones.length - index)"
                  >
                    <f7-card-content>
                      <f7-list class="list-form">
                        <ul class="no-margin no-padding">
                          <f7-row no-gap>
                            <r-input
                              class="col-40 medium-40 small-40"
                              floating-label
                              :label="$t('inspecciones.inspeccion_form.inicio')"
                              :form="rform"
                              :name="'sesiones.'+index+'.inicio'"
                              type="datetime-local"
                              :readonly="readonly"
                              :overrideReadonly="true"
                              :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                              :ignorePreviousVal="true"
                              :formatDate="'DD/MM/YYYY HH:mm'"
                            ></r-input>
                            <r-input
                              class="col-40 medium-40 small-40"
                              floating-label
                              :label="$t('inspecciones.inspeccion_form.fin')"
                              :form="rform"
                              :name="'sesiones.'+index+'.fin'"
                              type="datetime-local"
                              :readonly="readonly"
                              :overrideReadonly="true"
                              :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                              :ignorePreviousVal="true"
                              :formatDate="'DD/MM/YYYY HH:mm'"
                            ></r-input>
                            <span v-if="item && DateUtils.getDurationInSeconds(item.inicio, item.fin)" class="col-10 medium-15 small-20" style="padding-top: 10px;">
                              <f7-icon f7="alarm" color="primary"></f7-icon>{{DateUtils.getDifferenceInTime(item.inicio, item.fin)}}
                            </span>
                            <span v-else class="col-10 medium-15 small-20" style="padding-top: 10px;"> </span>
                          </f7-row>
                        </ul>
                      </f7-list>
                    </f7-card-content>
                    <f7-link
                      v-if="!readonly"
                      @click="eliminarSesionTarea(rform, index);"
                      class="margin-half"
                      style="position:absolute;right:0;top:0;"
                      icon-f7="trash"
                    ></f7-link>
                  </f7-card>
                </div>
                <r-input
                  outline
                  floating-label
                  :label="$t('tarea.importe')"
                  :form="rform"
                  name="importe"
                  type="number"
                  step=".01"
                ></r-input>
                <f7-row>
                  <r-input-badge
                    outline
                    class="col-100"
                    floating-label
                    :label="$t('tarea.numeroFactura')"
                    :form="rform"
                    name="facturas"
                    textProperty="numero"
                    :placeholder="$t('tarea.numeroFactura')"
                    :allowDuplicates="false"
                    delimiter="[\n\t\s,;:|]+"
                    :object-mode="true"
                    value-property="numero"
                    text-property="numero"
                    :badge-color="getBadgeColorForFactura"
                    @change="onFacturasChange"
                  ></r-input-badge>
                  <!-- <r-input
                    outline
                    class="col-40"
                    floating-label
                    :label="$t('tarea.numeroLineaFactura')"
                    :form="rform"
                    type="text"
                    name="numeroLineaFactura"
                  ></r-input> -->
                  <!-- <f7-link
                    v-if="rform.formData.idFactura"
                    class="col-20 link-externo"
                    :href="getUrl('facturas/view/' + rform.formData.idFactura + '/')"
                    icon-f7="arrow_up_right_square"
                    color="green"
                    :external="true"
                    v-tooltip="'Ver Factura'"
                  > Ver Factura</f7-link> -->
                  <!-- <div v-else class="col-20"></div> -->
                </f7-row>
                <f7-row>
                  <r-input
                    outline
                    class="col-80"
                    floating-label
                    :label="$t('tarea.codigoExpediente')"
                    :form="rform"
                    type="text"
                    name="codigoExpediente"
                  ></r-input>
                  <f7-link
                    v-if="rform.formData.idExpediente"
                    class="col-20 link-externo"
                    :href="getUrl('inspecciones/view/' + rform.formData.idExpediente + '/')"
                    icon-f7="arrow_up_right_square"
                    color="green"
                    :external="true"
                    v-tooltip="'Ver Expediente'"
                  > Ver Expediente</f7-link>
                  <div v-else class="col-20"></div>
                </f7-row>
                <f7-row>
                  <r-input
                    outline
                    class="col-40"
                    floating-label
                    :label="$t('tarea.numeroPedido')"
                    :form="rform"
                    type="text"
                    name="numeroPedido"
                  ></r-input>
                  <r-input
                    outline
                    class="col-40"
                    floating-label
                    :label="$t('tarea.numeroLineaPedido')"
                    :form="rform"
                    type="text"
                    name="numeroLineaPedido"
                  ></r-input>
                  <f7-link
                    v-if="rform.formData.idPedido"
                    class="col-20 link-externo"
                    :href="getUrl('pedidos/view/' + rform.formData.idPedido + '/')"
                    icon-f7="arrow_up_right_square"
                    color="green"
                    :external="true"
                    v-tooltip="'Ver Pedido'"
                  > Ver Pedido</f7-link>
                  <div v-else class="col-20"></div>
                </f7-row>
                <f7-row>
                  <r-input
                    class="col-80"
                    outline
                    floating-label
                    :label="$t('tarea.numeroOferta')"
                    :form="rform"
                    type="text"
                    name="numeroOferta"
                  ></r-input>
                  <f7-link
                    v-if="rform.formData.idOferta"
                    class="col-20 link-externo"
                    :href="getUrl('ofertas/view/' + rform.formData.idOferta + '/')"
                    icon-f7="arrow_up_right_square"
                    color="green"
                    :external="true"
                    v-tooltip="'Ver Oferta'"
                  > </f7-link>
                </f7-row>
                <f7-row>
                  <r-input
                    outline
                    class="col-80"
                    floating-label
                    :label="$t('tarea.codigoCliente')"
                    :form="rform"
                    type="text"
                    name="codigoCliente"
                  ></r-input>
                  <f7-link
                    v-if="rform.formData.idCliente"
                    class="col-20 link-externo"
                    :href="getUrl('clientes/view/' + rform.formData.idCliente + '/')"
                    icon-f7="arrow_up_right_square"
                    color="green"
                    :external="true"
                    v-tooltip="'Ver Cliente'"
                  > </f7-link>
                  <r-input
                    outline
                    class="col-80"
                    floating-label
                    :label="$t('tarea.codigoOportunidad')"
                    :form="rform"
                    type="text"
                    name="codigoOportunidad"
                  ></r-input>
                  <f7-link
                    v-if="rform.formData.idOportunidad"
                    class="col-20 link-externo"
                    :href="getUrl('oportunidades/view/' + rform.formData.idOportunidad + '/')"
                    icon-f7="arrow_up_right_square"
                    color="green"
                    :external="true"
                    v-tooltip="'Ver Oportunidad'"
                  > </f7-link>
                  <r-autocomplete-m2m
                    outline
                    :dbAdapter="Empleado"
                    key="doo"
                    class="col-100 medium-100"
                    floating-label
                    :label="$t('oportunidad.doo')"
                    :form="rform"
                    name="doo"
                    labelProp="nombre"
                    prefixProp="username"
                    :showNavigationLink="false"
                    type="textarea"
                    :lineBreak="true"
                    :shownFields="['username', 'nombre', 'rol']"
                  ></r-autocomplete-m2m>
                  <r-input
                    outline
                    class="col-80"
                    floating-label
                    :label="$t('tarea.codigoCampania')"
                    :form="rform"
                    type="text"
                    name="codigoCampania"
                  ></r-input>
                  <f7-link
                    v-if="rform.formData.idCampania"
                    class="col-20 link-externo"
                    :href="getUrl('campanias/view/' + rform.formData.idCampania + '/')"
                    icon-f7="arrow_up_right_square"
                    color="green"
                    :external="true"
                    v-tooltip="'Ver Campaña'"
                  > </f7-link>
                </f7-row>
                <r-direccion
                  :form="rform"
                  :name="'direccion'"
                  :guardarCodigos="true"
                  autocomplete="off"
                  :showNavigationLink="false"
                >
                </r-direccion>
                <r-input
                  outline
                  v-if="rform && rform.formData && rform.formData.comentariosPlanificacion"
                  floating-label
                  :label="$t('tarea.comentariosPlanificacion')"
                  :form="rform"
                  type="text"
                  name="comentariosPlanificacion"
                  :readonly="true"
                ></r-input>
              </ul>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <div class="margin-horizontal">
        <f7-segmented raised class="elevation-6 width-100">
          <f7-button fill tab-link="#tab-documentos">Documentación</f7-button>
          <f7-button fill tab-link="#tab-emails">e-Mails</f7-button>
        </f7-segmented>
      </div>
      <f7-tabs class="full-height" style="overflow: auto;">
        <f7-tab id="tab-documentos" tab-active>
          <f7-card class="elevation-3 padding-vertical-half padding-right">
            <f7-card-content>
              <div v-if="!rform.formData.documentos || (rform.formData.documentos && !rform.formData.documentos.length > 0)">La tarea no tiene documentos</div>
              <f7-list class="list-form">
                <ul>
                  <r-files 
                    :form="rform" 
                    name="documentos"
                    :documentoAdapter="Documento"
                  ></r-files>
                </ul>
              </f7-list>
            </f7-card-content>
          </f7-card>
        </f7-tab>
        <f7-tab id="tab-emails" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.codigo">
          <r-dynamic-list
            ref="rlist"
            :primary="['id']"
            :dbAdapter="RegistroEmail"
            :tableCode="'REGISTROEMAILTABS'"
            :tableMode="true"
            :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
            class="card full-height data-table"
            classContent="card-content full-height"
            :controlsWidth="50"
            :searchOnInit="true"
            :shownFields="['to','datos']"
            :mandatoryFilter ="{ 'datos##codigoTarea': $refs.rform.formData.codigo }"
            :funcShowCheck="_ => { return false; }"
            :massiveActions="false"
            useView="vista_RegistroEmails"
          >
            <template v-slot:optionsColumn="{ item }">
                <f7-link icon-f7="eye" color="green" @click="popupEmailEditable = false; emailId = item.id; popupEmailOpened = true"></f7-link>
            </template>
          </r-dynamic-list>
        </f7-tab>
      </f7-tabs>
      <pre style="display:none;">{{rform.formData}}</pre>

      <f7-popup ref="popupPlanificar"  swipe-to-close v-if="popupPlanificarOpened" :opened="true"  @popup:close="popupPlanificarOpened = false" >
      <f7-page v-if="rform && rform.formData">
        <f7-navbar title="Planificar Tarea">
          <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <r-form 
          ref="rformPlanificar" 
          @save="planificar()"
          :dbAdapter="null"
          classContent="full-height"
          :readonly="false"
        >
          <template v-slot:default="{ rform }">
            <f7-card
              class="elevation-3 padding-vertical-half padding-right"
            >
              <f7-card-content>
                <f7-list class="list-form">
                    <f7-row>
                      <f7-col width="100" medium="100">
                        <r-input
                            floating-label
                            class="col-100 medium-50"
                            :label="$t('tarea.fecha')"
                            :form="rform"
                            type="datepicker"
                            name="fechaFecha"
                            :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                        ></r-input>
                        <r-timepicker
                            floating-label
                            class="col-100 medium-50"
                            :label="$t('tarea.hora_inicio')"
                            :form="rform"
                            name="fechaHora"
                            :clearButton="true"
                        ></r-timepicker>
                        <r-input
                          floating-label
                          :label="$t('tarea.comentariosPlanificacion')"
                          :form="rform"
                          type="text"
                          name="comentariosPlanificacion"
                        ></r-input>
                      </f7-col>
                    </f7-row>
                </f7-list>
              </f7-card-content>
              <f7-row>
                <f7-col width="100" medium="100">
                  <f7-button
                      fill
                      icon-f7="disk"
                      :text="$t('common.guardar')"
                      class="display-flex margin-vertical"
                      color="green"
                      @click="rform.saveItem()"
                    ></f7-button>
                </f7-col>
              </f7-row>
 
            </f7-card>
          </template>
        </r-form>
      </f7-page>
    </f7-popup>
      </template>
      </r-form>
      <f7-popup ref="popupEmail" swipe-to-close :opened="true" v-if="popupEmailOpened" @popup:closed="popupEmailOpened = false; emailId = null">
      <registro-email-form :id="emailId" :editable="popupEmailEditable" @close="$refs.popupEmail.close();"  
        :defaultData="{ codigoTarea: $refs.rform.formData.codigo}" :esPopup="true"
      ></registro-email-form>
    </f7-popup>
    <envio-mail
      v-if="enviarEmail"
      ref="enviarEmail"
      :selected="filasSeleccionadas()"
      @email-enviado="enviarEmail = false"
    ></envio-mail>
    </f7-page-content>
  </f7-page>
</template>
<style scoped>

  .link-externo {
    margin-top: 20px;
  }
  .label-group {
    margin-top: 12px;
    margin-left: 20px;
    font-weight: bold;
  }
  .label-group-inspeccion {
    margin-top: 30px;
  }
  label.btn {
    padding: 1px;
    cursor: pointer;
    border: 1px solid;
  }

</style>
<script>
import Vue from "vue";
import rForm from "./../../components/rForm.vue";
import rDynamicList from "./../../components/rDynamicList.vue";
import rInput from "./../../components/rInput.vue";
import rInputBadge from "./../../components/rInputBadge.vue";
import rFiles from "./../../components/rFiles.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import EnvioMail from "./components/envio-mail.vue";
import Tarea from "./../../js/db/Tarea.js";
import Empleado from "./../../js/db/Empleado.js";
import TipoTarea from "./../../js/db/TipoTarea.js";
import rDireccion from "./../../components/rDireccion.vue";
import validator from "validator";
import rTimepicker from "./../../components/rTimepicker.vue";
import Factura from "./../../js/db/Factura.js";
import Documento from "./../../js/db/Documento.js";
import Utils from "./../../js/Utils.js";
import DateUtils from "./../../js/DateUtils.js";
import Oportunidad from "./../../js/db/Oportunidad.js";
import RegistroEmail from "../../js/db/RegistroEmail.js";
import RegistroEmailForm from "./../registroemail/registroemail-form.vue";
import RAutocompleteM2m from '../../components/rAutocompleteM2m.vue';
import ResultadoLlamada from './components/resultado-llamada.vue';
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  components: {
    rForm,
    rDynamicList,
    rInput,
    rInputBadge,
    rFiles,
    rAutocomplete,
    EnvioMail,
    rDireccion,
    rTimepicker,
    RegistroEmailForm,
    RAutocompleteM2m,
    ResultadoLlamada
  },
  data: function() {
    var self = this;
    return {
      Tarea,
      Empleado,
      TipoTarea,
      Factura,
      DateUtils,
      validator,
      readonly: !this.editable,
      popupPlanificarOpened: false, 
      Documento,
      RegistroEmail,
      popupTareaEditable: false,
      popupEmailOpened: false,
      emailId: null,
      popupEmailEditable: false,
      enviarEmail: false,
      showDetalle: true,
      sesionesWatcher: null,
      rformData: null,
      // Estado con el que se cargó la tarea: la anotación de la llamada (#934) se exige al pasarla
      // a REALIZADA, no al editar una que ya lo estaba.
      estadoInicial: null
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    },
    defaultData: {
      type: Object
    },
    esPopup: {
      type: Boolean,
      default: false
    }
  },

  computed: {},
  beforeDestroy() {},
  methods: {
    crearOportunidad() {
      const self = this;
      self.$f7.dialog.confirm('¿Está seguro de que desea crear una oportunidad?', 'Crear oportunidad', () => {
        // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        Oportunidad.save({
          data: { tarea: { id: self.$refs.rform.formData.id }, cliente: { id: self.$refs.rform.formData.idCliente }, oferta: { id: self.$refs.rform.formData.idOferta }, pedido: { id: self.$refs.rform.formData.idPedido }, lineaPedido: { numero: self.$refs.rform.formData.numeroLineaPedido }, gestor: Utils.getUser().username }
        }).then(res => {
          self.$set(self.$refs.rform.formData, 'codigoOportunidad', res.codigo);
          self.$set(self.$refs.rform.formData, 'idOportunidad', res.id);
          self.$f7.dialog.alert("Creada oportunidad " + res.codigo);
          window.open('#!/oportunidades/view/' + res.id + '/', "_blank");
        }).catch(function (error) {
          app.dialog.alert(error.message);
        }).then(_ => {
          espera.cerrar();
        });
      });
    },
    addSesionTarea(rform) {
      if (!rform || !rform.formData) {
        return;
      }
      if (!rform.formData.sesiones) {
        this.$set(rform.formData, 'sesiones', []);
      }
      rform.formData.sesiones.push({ inicio: new Date(), fin: null });
      this.actualizarTiempoEstimadoDesdeSesiones();
    },
    eliminarSesionTarea(rform, index) {
      if (!rform || !rform.formData || !rform.formData.sesiones) {
        return;
      }
      rform.formData.sesiones.splice(index, 1);
      this.actualizarTiempoEstimadoDesdeSesiones();
    },
    duracionAcumuladaSesiones(sesiones, tipoResultado = 'string') {
      if (!sesiones || !sesiones.length || !sesiones[0].inicio || !sesiones[0].fin) {
        return '';
      }
      let segundosTotales = sesiones.filter(s => s).reduce((acc, sesion) => {
        return acc + DateUtils.getDurationInSeconds(sesion.inicio, sesion.fin);
      }, 0);
      if (tipoResultado == 'number') {
        return DateUtils.getDurationString(segundosTotales);
      } else {
        return DateUtils.getDurationString(segundosTotales);
      }
    },
    actualizarTiempoEstimadoDesdeSesiones() {
      const formData = this.$refs.rform && this.$refs.rform.formData ? this.$refs.rform.formData : null;
      if (!formData || !formData.sesiones || !formData.sesiones.length) {
        return;
      }
      const totalMinutos = formData.sesiones
        .filter(sesion => sesion && sesion.inicio && sesion.fin)
        .reduce((acc, sesion) => {
          const segundos = DateUtils.getDurationInSeconds(sesion.inicio, sesion.fin);
          const minutos = Math.round(segundos / 60);
          return acc + minutos;
        }, 0);
      this.$set(formData, 'tiempoEstimado', totalMinutos);
    },
    setupSesionesWatcher() {
      if (this.sesionesWatcher || !this.$refs.rform || !this.$refs.rform.formData) {
        return;
      }
      this.sesionesWatcher = this.$watch(
        () => this.$refs.rform.formData.sesiones,
        () => {
          this.actualizarTiempoEstimadoDesdeSesiones();
        },
        { deep: true }
      );
    },
    changeEstado(e) {
      if (typeof e == 'string' && e == 'REALIZADA') {
        const self = this;
        if (!self.$refs.rform.formData.fechaFecha) {
          self.$set(self.$refs.rform.formData, 'fechaFecha', new Date());
          self.$set(self.$refs.rform.formData, 'fechaHora', new Date());
        }
      }
    },
    
    onFacturasChange(facturas) {
      const self = this;
      console.log('Facturas actualizadas:', facturas);
      
      // Normalizar cada factura para asegurar estructura consistente
      if (Array.isArray(facturas)) {
        const facturasNormalizadas = facturas.map((factura, index) => {
          // Si es un string, convertir a objeto
          if (typeof factura === 'string') {
            return {
              id: null,
              codigo: null,
              numero: factura,
              tipo: factura.length <= 7 ? 'ABONO' : 'FACTURA'
            };
          }
          // Si es un objeto, asegurar que tiene la estructura completa
          else if (typeof factura === 'object' && factura !== null) {
            return {
              id: factura.id || null,
              codigo: factura.codigo || null,
              numero: factura.numero || null,
              tipo: factura.tipo || null
            };
          }
          // Caso fallback
          else {
            return {
              id: null,
              codigo: null,
              numero: null,
              tipo: null
            };
          }
        });
        
        console.log('Facturas normalizadas:', facturasNormalizadas);
        // Actualizar el array con objetos consistentes
        self.$set(self.$refs.rform.formData, 'facturas', facturasNormalizadas);
      }
    },

    getBadgeColorForFactura(elemento) {
      // Función que determina el color del badge basado en el tipo de factura
      if (elemento && elemento.tipo) {
        switch (elemento.tipo.toLowerCase()) {
          case 'factura':
            return 'blue';
          case 'abono':
            return 'orange';
          default:
            return 'gray';
        }
      }
      return 'gray';
    },

    async validarFacturaExiste(codigo) {
      // Método opcional para validar si una factura existe
      if (!codigo || !codigo.trim()) return false;
      
      try {
        const filtro = { codigo: codigo.trim() };
        const resultado = await Factura.getAll({ filter: filtro });
        return resultado && resultado.length > 0;
      } catch (error) {
        console.error(`Error al validar factura ${codigo}:`, error);
        return false;
      }
    },

    async completarDatosFactura(codigo) {
      // Método opcional para completar datos de una factura específica
      if (!codigo || !codigo.trim()) return null;
      
      try {
        const filtro = { codigo: codigo.trim() };
        const resultado = await Factura.getAll({ filter: filtro });
        
        if (resultado && resultado.length > 0) {
          const factura = resultado[0];
          return {
            codigo: factura.codigo,
            numero: factura.numero || null,
            tipo: factura.tipo || null
          };
        }
        return null;
      } catch (error) {
        console.error(`Error al completar datos de factura ${codigo}:`, error);
        return null;
      }
    },
    tareaSiguiente() {
      const self = this;
      const tarea = self.$refs.rform.formData;
      delete tarea.id;
      delete tarea.comentariosPlanificacion;
      delete tarea.horaInicio;
      tarea.estado = "PENDIENTE";
      Tarea.post({ data: tarea }).then((res) => {
        window.open(self.getUrl('tarea/view/' + res.id + '/'));
      }).catch(e => app.dialog.alert(error.message))
    },
    getUrl(url) {
      const self = this;
      var currentUrl = new URL(window.location.href);
      if (self.target == 'cordova') {
        return '/' + url;
      }
      return currentUrl.pathname + ('#!/' + url);
    },
    getColorBadgeEstado: function(estado) {
      const colores = [
        {
          "nombre": "PENDIENTE",
          "valor": "orange"
        },
        {
          "nombre": "PLANIFICADA",
          "valor": "blue"
        },
        {
          "nombre": "REALIZADA",
          "valor": "teal"
        },
        {
          "nombre": "CANCELADA",
          "valor": "red"
        }
      ];
      
      const colorItem = colores.find(item => item.nombre === estado);
      return colorItem ? colorItem.valor : "gray";
    },
    getTextBadgeEstado: function(estado) {
      let texto = "gray";
        switch (estado) {
          case "PENDIENTE":
            texto = "Tarea Pendiente de Gestionar";
            break;
          case "PLANIFICADA":
            texto = "Tarea Planificada";
            break;
          case "REALIZADA":
            texto = "Tarea Realizada";
            break;
          case "CANCELADA":
            texto = "Tarea Cancelada";
            break;
        }
      return texto;
    },

    desplanificarTarea: function() {
      var self = this;

      app.dialog.confirm(
        "¿Seguro que desea desplanificar esta tarea?",
        "Desplanificar",
        function() {
          
          Tarea.desplanificar({itemId: self.id, data: self.$refs.rform.formData }).then(function(res) {
            if (res) {
                self.$refs.rform.formData = res.dto;
                self.readonly = true;
              app.toast
                .create({
                  icon: '<i class="f7-icons">checkmark</i>',
                  text: "Tarea desplanificada correctamente",
                  position: "center",
                  destroyOnClose: true,
                  closeTimeout: 2000
                })
                .open();
            }
          }).catch(function(error){
            app.dialog.alert(error.message);
          }).finally(function(e) {
            app.preloader.hide();
            self.loadItem(); 
          })
        }
      );

      

    },

    planificar: function() {
      var self = this;
      self.$refs.popupPlanificar.close();
      var app = self.$f7;

      var formDataPlanificar = self.$refs.rformPlanificar.formData;

      var dateInicio = new Date (formDataPlanificar.fechaFecha);
      var horaInicio = new Date (formDataPlanificar.fechaHora);

      
      dateInicio.setHours(horaInicio.getHours());
      dateInicio.setMinutes(horaInicio.getMinutes());
      dateInicio.setSeconds(horaInicio.getSeconds());
      dateInicio.setMilliseconds(horaInicio.getMilliseconds());

      if (!self.$refs.rform.formData.username) {
        app.dialog.alert("Debe asignar la tarea a un empleado");
        return;
      }

      app.dialog.confirm(
        "¿Seguro que desea planificar esta tarea?",
        "Planificar",
        function() {
          // Se enciende al aceptar y no antes: sin empleado, o cancelando el diálogo, no hay nada
          // que esperar, y un testigo sin soltar ya no lo apagaría nadie en toda la sesión.
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          
         var dataSend = JSON.parse(JSON.stringify( Object.assign({}, self.$refs.rform.formData, {horaInicio: dateInicio, comentariosPlanificacion: formDataPlanificar.comentariosPlanificacion })));
          
          Tarea.planificar({itemId: dataSend.id, data: dataSend}).then(function(res) {
            if (res) {
                self.$refs.rform.formData = res.dto;
                self.readonly = true;
              app.toast
                .create({
                  icon: '<i class="f7-icons">checkmark</i>',
                  text: "Tarea planificada correctamente",
                  position: "center",
                  destroyOnClose: true,
                  closeTimeout: 2000
                })
                .open();
            }
          }).catch(function(error){
            app.dialog.alert(error.message);
          }).finally(function(e) {
            espera.cerrar();
            self.loadItem(); 
          })
        }
      );

    },
    loadItem: function() {
      var self = this;
      var formData = self.$refs.rform.formData;
      var horaFinal = new Date (new Date (formData.horaInicio).getTime() + formData.tiempoEstimado * 60000);
      self.$set(formData, "fechaFecha", formData.horaInicio);
      self.$set(formData, "fechaHora", formData.horaInicio);
      self.$set(formData, "horaFinal", horaFinal);
      self.estadoInicial = formData.estado || null;
      self.setupSesionesWatcher();
      self.actualizarTiempoEstimadoDesdeSesiones();
      self.rformData = formData;

    },
    deleteItem: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          Tarea.delete({itemId: self.id}).then(function(res) {
            if (res) {
              app.toast
                .create({
                  icon: '<i class="f7-icons">checkmark</i>',
                  text: self.$t("rlist.registro_eliminado"),
                  position: "center",
                  destroyOnClose: true,
                  closeTimeout: 2000
                })
                .open();
              self.$f7router.back()
            }
          }).catch(function(error){
            app.dialog.alert(error.message);
          });
        }
      );
    },
    beforeSave: function (data, resolve, reject, llamadaComprobada) {
      var self = this;
      var formData = data;
      const resultadoLlamada = self.$refs.resultadoLlamada;
      // Hasta que llega la configuración de la llamada no se sabe si hay que anotarla: se espera y
      // se vuelve a pasar por aquí, o un guardado rápido cerraría la llamada sin anotar. Si la carga
      // falló al cerrar, se reintenta una vez; y si vuelve a fallar no se cierra a ciegas.
      if (resultadoLlamada && !llamadaComprobada
          && (!resultadoLlamada.cargado || resultadoLlamada.cierreSinComprobar())) {
        resultadoLlamada.listo(true).then(function() {
          self.beforeSave(data, resolve, reject, true);
        });
        return;
      }
      if (resultadoLlamada && resultadoLlamada.cierreSinComprobar()) {
        reject({ message: "No se ha podido comprobar si esta tarea es una llamada que hay que anotar (" + resultadoLlamada.errorCarga + "), así que no se ha guardado como REALIZADA. Pulsa «Reintentar» en «Resultado de la llamada», debajo de «Comentarios»; si sigue fallando, avisa a soporte." });
        return;
      }
      if (resultadoLlamada && resultadoLlamada.faltaAnotar()) {
        reject({ message: "Para cerrar esta llamada anota el resultado, el motivo y el siguiente paso en «Resultado de la llamada», debajo de «Comentarios»." });
        return;
      }
      var dateInicio = new Date (formData.fechaFecha);
      var horaInicio = new Date (formData.fechaHora);
      // var horaFinal = new Date (formData.horaFinal);

      
      dateInicio.setHours(horaInicio.getHours());
      dateInicio.setMinutes(horaInicio.getMinutes());
      dateInicio.setSeconds(horaInicio.getSeconds());
      dateInicio.setMilliseconds(horaInicio.getMilliseconds());

      // horaFinal.setDate(dateInicio.getDate());

      // var tiempo = (horaFinal.getTime() - dateInicio.getTime())/60000;


      self.$set(formData, "horaInicio", dateInicio);
      if (formData.sesiones && formData.sesiones.length) {
        const totalMinutos = formData.sesiones
          .filter(sesion => sesion && sesion.inicio && sesion.fin)
          .reduce((acc, sesion) => {
            const segundos = DateUtils.getDurationInSeconds(sesion.inicio, sesion.fin);
            const minutos = Math.round(segundos / 60);
            return acc + minutos;
          }, 0);
        self.$set(formData, "tiempoEstimado", totalMinutos);
      }
      // self.$set(formData, "tiempoEstimado", tiempo);

      resolve(formData);

    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;


      self.$refs.rform.formData = res;
      self.readonly = true;
      app.toast
        .create({
          text: self.$t("tarea.guardado_ok"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
      self.loadItem();
      // La anotación de la llamada (#934) va al CRM después de la tarea. Si falla, la tarea ya está
      // guardada: se dice, y el bloque se queda con lo elegido y su botón para reintentar.
      const resultadoLlamada = self.$refs.resultadoLlamada;
      if (resultadoLlamada) {
        resultadoLlamada.guardarSiHaceFalta().catch(function(e) {
          app.dialog.alert("La tarea se ha guardado, pero el resultado de la llamada no: " + ((e && e.message) || "error desconocido") + ". Puedes guardarlo desde «Resultado de la llamada», en esta misma ficha.");
        });
      }
      self.$emit('saved', res);
    },
    filasSeleccionadas: function() {
      const self = this;
      let filas = [self.$refs.rform.formData].map(selected => {
        return {id: selected.id};
      });
      return filas;
    },

    procesarParametrosUrl() {
      var self = this;
      
      // Obtener parámetros de la URL
      let parametros = self.$f7route.url.split('?')[1];
      if (parametros) {
        try {
          // Buscar el parámetro jsonData
          const urlParams = new URLSearchParams(parametros);
          const jsonDataParam = urlParams.get('jsonData');
          
          if (jsonDataParam) {
            const dataTarea = JSON.parse(jsonDataParam);
            console.log('Datos de tarea obtenidos de la URL:', dataTarea);
            // Si hay datos de tarea, prellenar los campos correspondientes
            if (dataTarea && typeof dataTarea === 'object') {
              // Esperar a que el formulario esté listo
              self.$nextTick(() => {
                if (self.$refs.rform) {
                  // Iterar sobre las propiedades del objeto y asignarlas al formulario
                  Object.keys(dataTarea).forEach(campo => {
                    if (dataTarea[campo] !== null && dataTarea[campo] !== undefined) {
                      self.$set(self.$refs.rform.formData, campo, dataTarea[campo]);
                    }
                  });
                } else {
                  // Si el formulario no está listo, esperar un poco más
                  setTimeout(() => {
                    if (self.$refs.rform) {
                      Object.keys(dataTarea).forEach(campo => {
                        if (dataTarea[campo] !== null && dataTarea[campo] !== undefined) {
                          self.$set(self.$refs.rform.formData, campo, dataTarea[campo]);
                        }
                      });
                    }
                  }, 500);
                }
              });
            }
          }
        } catch (error) {
          console.error('Error procesando parámetros de URL:', error);
        }
      }
    },
    
    cancelarEdicion(){
      var self = this;
      self.$refs.rform.cancelEdit();
      self.readonly = true;
    },
    onRFormMounted() {
      if (this.$refs.rform && this.$refs.rform.formData) {
        this.rformData = this.$refs.rform.formData;
      }
      this.setupSesionesWatcher();
    }

  },
  created: function() {
    var self = this;
    var $ = self.$$;
    var $el = $(self.$el);
    var app = self.$f7;
    
    // Procesar parámetros de la URL para prellenar campos
    self.procesarParametrosUrl();
  },
  mounted: function() {
    this.setupSesionesWatcher();
  }
}
</script>